import React, { PropsWithChildren } from 'react';
import { StyleProp, StyleSheet, View, ViewProps } from 'react-native';

import Image from './Image';
import { deviceWidth } from '../Theme/styles';
import { getEnvValue } from '../Helper/env';

type Props = {
  height: number;
  markers: { latitude: number | string; longitude: number | string }[];
  zoom?: any;
  style?: StyleProp<ViewProps>;
  width: number;
  withRadius?: boolean;
  props?: any;
};
const MapSnapShotPreview = ({
  height = 200,
  markers,
  zoom,
  style,
  width = deviceWidth,
  withRadius,
  ...props
}: PropsWithChildren<Props>) => {
  const mapsApiKey = getEnvValue('RAZZLE_GOOGLE_MAPS_API_KEY', {
    nativeKey: 'GOOGLE_MAPS_API_KEY',
  });
  const size = `${Math.round(width)}x${height}`;
  let staticGmap = `https://maps.googleapis.com/maps/api/staticmap?zoom=${zoom}&size=${size}&key=${mapsApiKey}&`;

  markers.forEach((marker) => {
    staticGmap += `markers=color:red|${marker.latitude},${marker.longitude}&`;
  });

  return (
    <View
      style={[withRadius ? styles.container : {}, StyleSheet.flatten(style)]}
    >
      {
        //@ts-ignore:JS Code error
        <Image
          source={{ uri: staticGmap }}
          style={[styles.snapshot, { height }]}
          resizeMode="cover"
        />
      }
      {props.children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    borderRadius: 10,
    overflow: 'hidden',
  },
  snapshot: {
    width: '100%',
  },
});

export default MapSnapShotPreview;
